export function useViewport() {
  const width = ref(window?.innerWidth || 0);
  const height = ref(window?.innerHeight || 0);

  function update() {
    width.value = window?.innerWidth || 0;
    height.value = window?.innerHeight || 0;
  }

  onMounted(() => window?.addEventListener('resize', update));
  onUnmounted(() => window?.removeEventListener('resize', update));

  return {
    width: width,
    height: height,
  };
}
